import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../../shared/services/auth.service";
import {firstValueFrom, Observable} from "rxjs";
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  constructor(private http: HttpClient, private authService : AuthService) {
  }

  private url(path: string): string {
      const base =
        this.authService.getOriginCurrency() !== 'BRL'
          ? environment.intlUrl   
          : environment.apiUrl;

      return `${base}${path}`;
    }

  getAccount() : Promise<any>
  {
    return firstValueFrom(this.http.get<any>(this.url('/account')));
  }

  getAccountTaxes() : Promise<any>
  {
    return firstValueFrom(this.http.get(`${environment.apiUrl}/account/taxes`));
  }
  getAccounts() : Observable<any>
  {
    return this.http.get(`${environment.apiUrl}/accounts`);
  }
  insertAccount(account: any)
  {
    return this.http.post<any>(`${environment.apiUrl}/account`, account);
  }

  setWithdrawAutomatic(isAutomatic: boolean)
  {
    return this.http.post<any>(`${environment.apiUrl}/account/setWithdrawAutomatic`,{isAutomatic});
  }

}
